import { type ReactElement, useCallback } from 'react';
import { FormField, Header, type HVStackProps, VStack } from '@direct-frontend/components';
import { GeoInput } from '@/entities/geoSuggest';
import { type MapSubmitButtonComponent } from '@/shared/api/map';
import { type OrderDto } from '@/shared/api/order';
import { FormFieldLabel } from '@/shared/components/FormFieldLabel';
import { usePickupAddressContext } from '../../PickupAddressContext';
import type { PickupAddressValue } from '../../types/PickupAddressValue';
import { PickupAddressDetails } from '../PickupAddressDetails';
import styles from './PickupAddressSidebar.module.css';

interface PickupAddressSidebarProps extends HVStackProps {
    title: string;
    order: OrderDto;
    storeSlug: string;
    inputValue: string;
    showGeoInput?: boolean;
    filtersSlot?: ReactElement<HTMLElement>;
    onChange: (point: PickupAddressValue) => void;
    onInputChange: (value: string) => void;
    submitButton: MapSubmitButtonComponent;
    reinitializeOrderForm: (initialOrder: OrderDto, updatedOrder: OrderDto) => void;
}

export const PickupAddressSidebar = (props: PickupAddressSidebarProps) => {
    const {
        order,
        storeSlug,
        inputValue,
        onInputChange,
        onChange,
        title,
        filtersSlot,
        showGeoInput = true,
        submitButton,
        reinitializeOrderForm,
        ...other
    } = props;
    const { pickupPoint, onSelectPickupPoint, allItemsCount } = usePickupAddressContext();
    const onPointReset = useCallback(() => onSelectPickupPoint(null), [onSelectPickupPoint]);

    return (
        <VStack {...other} gap="24">
            {pickupPoint ? (
                <PickupAddressDetails
                    className={styles.details}
                    point={pickupPoint}
                    order={order}
                    reinitializeOrderForm={reinitializeOrderForm}
                    storeSlug={storeSlug}
                    allItemsCount={allItemsCount}
                    onClose={onPointReset}
                    onChange={onChange}
                    submitButton={submitButton}
                />
            ) : (
                <VStack gap="20">
                    <VStack gap="8">
                        <Header level="h2" className={styles.title}>
                            {title}
                        </Header>
                        {showGeoInput && (
                            <FormField label={<FormFieldLabel>Адрес</FormFieldLabel>}>
                                {(inputProps) => (
                                    <GeoInput {...inputProps} size="m" value={inputValue} onChange={onInputChange} />
                                )}
                            </FormField>
                        )}
                    </VStack>
                    {filtersSlot ? filtersSlot : null}
                </VStack>
            )}
        </VStack>
    );
};
